import Filtrar from '@mui/icons-material/FilterList';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { action, computed, makeObservable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import DrawerFiltros from './DrawerFiltros';
import ReactComponent from './ReactComponent';
import IconeLimpar from './sessao/icones/IconeLimpar';

class PainelFiltros extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            backdropOpen: computed,
            abrirPainelFiltros: action,
            limparFiltros: action,
            titleFiltrar: computed,
            labelsFiltrosAtivos: computed
        });

        this.createReaction(
            reaction(
                () => this.backdropOpen,
                () => (this.appStore.backdropOpen = this.backdropOpen)
            )
        );
    }

    get backdropOpen() {
        return (
            this.store.carregandoProcessos ||
            this.store.alterandoValorFiltro ||
            this.store.filtros.existeFiltroCarregando
        );
    }

    abrirPainelFiltros = () => {
        this.store.painelFiltros = true;
    };

    limparFiltros = () => {
        this.store.resetFiltros();
    };

    get titleFiltrar() {
        return this.store.existeFiltroAtivo ? `Filtros ativos:${this.labelsFiltrosAtivos}` : 'Filtrar';
    }

    get labelsFiltrosAtivos() {
        let retorno = '';
        this.store.filtros.filtrosComValor.forEach((filtro) => (retorno += '\n' + filtro.label));
        return retorno;
    }

    render() {
        return (
            <>
                <DrawerFiltros />
                <Tooltip
                    title={<Typography>{this.titleFiltrar}</Typography>}
                    placement="top-start"
                >
                    <Box className="corBotao">
                        <Filtrar
                            onClick={this.abrirPainelFiltros}
                            style={{
                                cursor: 'pointer',
                                width: '24px',
                                height: '24px',
                                color: !this.store.existeFiltroAtivo ? 'black' : '#b71c1c'
                            }}
                        />
                    </Box>
                </Tooltip>
                {this.store.existeFiltroAtivo && (
                    <Box className="corBotao">
                        <Tooltip
                            title={<Typography>Limpar Filtros</Typography>}
                            placement="top-start"
                        >
                            <Box
                                style={{ margin: '0px 10px' }}
                                onClick={this.limparFiltros}
                            >
                                <IconeLimpar style={{ cursor: 'pointer' }} />
                            </Box>
                        </Tooltip>
                    </Box>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(PainelFiltros));
